import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { AlertSize, AlertType } from '@design-system/components/molecules/alert/entities/alert.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { AlertMessageType } from '@ux/components/alert-message/alert-message-type';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AlertMessageComponent {

  @Input() text: string;
  @Input() alertType: AlertMessageType = AlertMessageType.DEFAULT;

  public readonly icons = Icon;
  public readonly alertSize = AlertSize;

  constructor() { }

  get dsType(): AlertType {
    return this.alertType === AlertMessageType.ERROR ? AlertType.Error : this.alertType === AlertMessageType.WARNING ?
      AlertType.Warning : AlertType.Default;
  }

}
